const appfont = {
    'thin':'Montserrat-Thin',
    'regular':'Montserrat-Regular',
    'semibold':'Montserrat-SemiBold',
    'bold':'Montserrat-Bold'
}

export default appfont